/**
 * Screen order for onboarding round 2 Part B. Index, the auth listener, the
 * ?screen= shortcut and the progress bar all read these numbers, so a move of
 * one screen changes every route in one place.
 */
export const SCREEN = {
  welcome: 0,
  score: 1,
  priorities: 2,
  location: 3,
  picks: 4, // Your picks, or No cafés nearby (same position)
  account: 5,
  aboutYou: 6,
  notifications: 7,
  finish: 8,
} as const;

export const LAST_SCREEN = SCREEN.finish;

/** Where an account that exists but has not finished onboarding resumes. */
export const RESUME_SCREEN = SCREEN.aboutYou;

/** Steps that count on the progress bar (Welcome and Finish show none). */
export const PROGRESS_STEPS = 7;

/** Event step name per screen. Screen 4 depends on which variant shows. */
export function stepNameFor(screen: number, picksVariant: "picks" | "waitlist" = "picks"): string | null {
  switch (screen) {
    case SCREEN.welcome: return "welcome";
    case SCREEN.score: return "grounded_score";
    case SCREEN.priorities: return "priorities";
    case SCREEN.location: return "location";
    case SCREEN.picks: return picksVariant;
    case SCREEN.account: return "auth";
    case SCREEN.aboutYou: return "demographics";
    case SCREEN.notifications: return "notifications";
    case SCREEN.finish: return "celebration";
    default: return null;
  }
}

/**
 * Fill of the continuous progress bar, 0 to 1, or null when no bar shows.
 * Score is 1 of 7 through Notifications 7 of 7.
 */
export function progressFor(screen: number): number | null {
  if (screen <= SCREEN.welcome || screen >= SCREEN.finish) return null;
  return screen / PROGRESS_STEPS;
}

/** Every step has a back arrow except Welcome, About you and Finish. */
export function hasBackArrow(screen: number): boolean {
  return screen !== SCREEN.welcome && screen !== SCREEN.aboutYou && screen !== SCREEN.finish;
}
